import {useEffect, useState} from 'react';
import {IStep} from '@redux/types';

export const useGetMainStepCount = (steps: IStep[]) => {
  const [mainStepCount, setMainStepCount] = useState<number>(0)

  useEffect(() => {
    setMainStepCount(steps?.filter((s: IStep) => !!s?.step?.displayStepNumber)?.length || 0)
  }, [steps])

  return mainStepCount
}
